import React, { useEffect } from 'react';
import DualView from '../layout/DualView';

const HomePage = () => {
    // Always start at the top on page load.
    // Browsers can restore prior scroll position on refresh, which makes
    // visitors miss the hero. Force a clean entry every time.
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    // DualView handles everything: the splash chooser, the persistent
    // designer/developer panes, and the EdgeTab. Both panes stay
    // mounted at all times — switching views slides the track instead
    // of unmounting and re-rendering.
    return (
        <div className='HomePage'>
            <DualView />
        </div>
    );
};

export default HomePage;
